import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  error: string | null;
}

const NoTokensBanner: React.FC<Props> = ({ error }) => {
  if (!error) return null;

  if (error.toLowerCase().includes('tarot do dia hoje')) {
    return (
      <div
        className="rounded-xl p-4 mb-4 text-center"
        style={{ background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.3)' }}
      >
        <p className="text-purple-300 font-semibold mb-1">Leitura do dia já realizada</p>
        <p className="text-white/60 text-sm">Volte amanhã para sua próxima consulta gratuita.</p>
      </div>
    );
  }

  if (error.toLowerCase().includes('insuficientes')) {
    return (
      <div
        className="rounded-xl p-4 mb-4 text-center"
        style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)' }}
      >
        <p className="text-amber-300 font-semibold mb-1">Você não tem tokens suficientes</p>
        <p className="text-white/60 text-sm mb-3">Adquira tokens para continuar suas consultas com Aurora Lyz.</p>
        <Link
          to="/checkout"
          className="inline-block px-5 py-2 rounded-xl text-white font-semibold text-sm transition-opacity hover:opacity-90"
          style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}
        >
          Comprar tokens
        </Link>
      </div>
    );
  }

  return <p className="text-red-300 text-sm text-center mb-4">{error}</p>;
};

export default NoTokensBanner;
